import { formatNumberParts } from '@/utils/formatValueWithUnit'

type ValueWithUnitProps = {
    value: number
    unit: string
}

const ValueWithUnit: React.FC<ValueWithUnitProps> = ({ value, unit }) => {
    const { integer, fraction } = formatNumberParts(value)
    const isCurrency = unit === '$'

    return (
        <>
            <span className="text-paragraph font-semibold leading-8">
                {isCurrency ? '$' : ''}
                {integer}
            </span>
            <span className="text-label-medium leading-6">
                {fraction} {isCurrency ? '' : unit}
            </span>
        </>
    )
}

export default ValueWithUnit
